import { createClient } from '@supabase/supabase-js';

// الـ Publishable Key مصمم إنه يكون عام (الحماية الحقيقية في الـ RLS)
// لكن أي مفتاح سري — Paymob API Key / HMAC / Service Key — ممنوع يكون هنا نهائيًا.
export const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL || 'https://ubzuvtcskkxlaxgfwfsx.supabase.co',
  process.env.REACT_APP_SUPABASE_KEY || 'sb_publishable_LyvOVjmG8EGl2gqaEFovrQ_OlW-sSeE'
);

// ⚠️ اتشال من هنا (كان مكشوف في الـ bundle):
//   - PAYMOB.API_KEY  → بقى PAYMOB_API_KEY في env السيرفر، والأوردر بيتعمل عبر /api/paymob/init
//   - PAYMOB.HMAC     → بقى PAYMOB_HMAC في env السيرفر، والتحقق في الـ webhook بس
// الباقي هنا قيم غير سرية (بتظهر أصلًا في رابط الـ iframe).
export const PAYMOB = {
  CARD_IFRAME: '1017313',
};

// ── helper موحد لنداء الـ API ──────────────────────────────
// في الـ dev: السيرفر شغال على بورت 3001
// في الـ production: نفس الدومين (Render Web Service)
export const apiUrl = (path) => {
  const isLocal = typeof window !== 'undefined' && window.location.hostname === 'localhost';
  return isLocal ? `http://localhost:3001${path}` : path;
};
